import capitalize from 'lodash/capitalize';
import clamp from 'lodash/clamp';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import groupBy from 'lodash/groupBy';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import partial from 'lodash/partial';
import range from 'lodash/range';
import throttle from 'lodash/throttle';
import uniqWith from 'lodash/uniqWith';
import uniqueId from 'lodash/uniqueId';

export {
    noop,
    omit,
    clamp,
    range,
    groupBy,
    partial,
    debounce,
    throttle,
    uniqWith,
    uniqueId,
    isString,
    capitalize,
    isEqual,
    isFunction,
    cloneDeep,
};
